// CLINIC
export const getGlobalErrorMsg          = (store) =>  store.clinic?.errorMsg;
export const getCurrentNavTab           = (store) =>  store.clinic?.currentNavTab;
export const getIsSidebarMobileOpen     = (store) =>  store.clinic?.isSidebarMobileOpen;

export const getCompanyList    = (store) =>  store.company?.companyList;
export const getACompany       = (store) =>  store.company?.companyDetail;
export const getCompanyLogoUrl = (store) =>  store.company?.companyLogoUrl;
export const getCompanyActionStatus  = (store) =>  store.company?.actionStatus;
export const getCompanyActionMsg  = (store) =>  store.company?.actionMsg;
export const getCompanyError   = (store) =>  store.company?.error;

export const getUserList       = (store) =>  store.user?.userList;
export const getAUser          = (store) =>  store.user?.userDetail;
export const getUserActionStatus     = (store) =>  store.user?.actionStatus;
export const getUserActionMsg     = (store) =>  store.user?.actionMsg;
export const getUserError   = (store) =>  store.user?.error;

export const getDoctorList    = (store) =>  store.doctor?.doctorList;
export const getADoctor       = (store) =>  store.doctor?.doctorDetail;
export const getDoctorActionStatus  = (store) =>  store.doctor?.actionStatus;
export const getDoctorActionMsg  = (store) =>  store.doctor?.actionMsg;
export const getDoctorError   = (store) =>  store.doctor?.error;

export const getDepartmentList    = (store) =>  store.department?.departmentList;
export const getADepartment       = (store) =>  store.department?.departmentDetail;
export const getDepartmentActionStatus  = (store) =>  store.department?.actionStatus;
export const getDepartmentActionMsg  = (store) =>  store.department?.actionMsg;
export const getDepartmentError   = (store) =>  store.department?.error;

export const getPatientList    = (store) =>  store.patient?.patientList;
export const getAPatient       = (store) =>  store.patient?.patientDetail;
export const getPatientActionStatus  = (store) =>  store.patient?.actionStatus;
export const getPatientActionMsg  = (store) =>  store.patient?.actionMsg;
export const getPatientError   = (store) =>  store.patient?.error;
export const getPatientTotalCount    = (store) =>  store.patient?.totalCount;
export const getPatientOffset        = (store) =>  store.patient?.offset;
export const getPatientListRemoteCSV = (store) =>  store.patient?.remoteCSV;
export const getPatientListRemoteExcel = (store) =>  store.patient?.remoteEXCEL;

export const getScheduleMedicalList    = (store) =>  store.scheduleMedical?.scheduleMedicalList;
export const getAScheduleMedical       = (store) =>  store.scheduleMedical?.scheduleMedicalDetail;
export const getScheduleMedicalActionStatus  = (store) =>  store.scheduleMedical?.actionStatus;
export const getScheduleMedicalActionMsg  = (store) =>  store.scheduleMedical?.actionMsg;
export const getScheduleMedicalError   = (store) =>  store.patient?.error;

export const getPatientResultList    = (store) =>  store.patientResult?.patientResultList;
export const getAPatientResult       = (store) =>  store.patientResult?.patientResultDetail;
export const getPatientResultActionStatus  = (store) =>  store.patientResult?.actionStatus;
export const getPatientResultActionMsg  = (store) =>  store.patientResult?.actionMsg;
export const getPatientResultError   = (store) =>  store.patientResult?.error;
export const getMedicineRemotePDF          = (store) =>  store.patientResult?.remotePDF;

export const getServicePriceList            = (store) =>  store.servicePrice?.servicePriceList;
export const getAServicePrice               = (store) =>  store.servicePrice?.servicePriceDetail;
export const getServicePriceActionStatus    = (store) =>  store.servicePrice?.actionStatus;
export const getServicePriceActionMsg    = (store) =>  store.servicePrice?.actionMsg;
export const getServicePriceError           = (store) =>  store.servicePrice?.error;
export const getServicePriceTotalCount      = (store) =>  store.servicePrice?.totalCount;
export const getServicePriceOffset          = (store) =>  store.servicePrice?.offset;
export const getServicePriceListRemoteCSV   = (store) =>  store.servicePrice?.remoteCSV;
export const getServicePriceListRemoteExcel = (store) =>  store.servicePrice?.remoteEXCEL;

export const getMedicineList    = (store) =>  store.medicine?.medicineList;
export const getAMedicine       = (store) =>  store.medicine?.medicineDetail;
export const getMedicineActionStatus  = (store) =>  store.medicine?.actionStatus;
export const getMedicineActionMsg  = (store) =>  store.medicine?.actionMsg;
export const getMedicineError   = (store) =>  store.medicine?.error;
export const getMedicineTotalCount    = (store) =>  store.medicine?.totalCount;
export const getMedicineOffset        = (store) =>  store.medicine?.offset;
export const getMedicineImportExportList    = (store) =>  store.medicine?.medicineImportExportList
export const getMedicineListRemoteCSV = (store) =>  store.medicine?.remoteCSV; 
export const getMedicineListRemoteExcel = (store) =>  store.medicine?.remoteEXCEL;

export const getEnterpriseList              = (store) =>  store.enterprise?.enterpriseList;
export const getAEnterprise                 = (store) =>  store.enterprise?.enterpriseDetail;
export const getEnterpriseActionStatus      = (store) =>  store.enterprise?.actionStatus;
export const getEnterpriseActionMsg      = (store) =>  store.enterprise?.actionMsg;
export const getEnterpriseError             = (store) =>  store.enterprise?.error;

export const getASystemSetting              = (store) =>  store.systemSetting?.systemSettingDetail;
export const getSystemSettingActionStatus   = (store) =>  store.systemSetting?.actionStatus;
export const getSystemSettingActionMsg   = (store) =>  store.systemSetting?.actionMsg;
export const getSystemSettingError                = (store) =>  store.systemSetting?.error;

export const getUserLogList                 = (store) =>  store.userLog?.userLogList;
export const getUserLogTotalCount           = (store) =>  store.userLog?.totalCount;
export const getUserLogOffset               = (store) =>  store.userLog?.offset;

export const getPaymentList                 = (store) =>  store.payment?.paymentList;
export const getPaymentTotalCount           = (store) =>  store.payment?.totalCount;
export const getPaymentOffset               = (store) =>  store.payment?.offset;